import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
// import { FaSliders } from "react-icons/fa6";
import User from "../../assets/images/james-img.png";
import { toast } from "react-toastify";
import { CLIENT } from "../../Router/paths";
import { useLoader } from "../../context/LoaderContext";
import { axiosInstance } from "../../config/https";

export default function ReviewProposalsComp() {
  const { startLoader, stopLoader } = useLoader();
  const { id } = useParams();
  const [proposals, setProposals] = useState([]);
  const [filterProposals, setFilterProposals] = useState([]);

  useEffect(() => {
    const getProposals = () => {
      startLoader();
      axiosInstance
        .get(`/api/job-proposals/?job_post_id=${id}`)
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setProposals(Data.data);
            setFilterProposals(Data.data);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getProposals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (event) => {
    const value = event.target.value.toLowerCase();
    const filteredData = proposals.filter((item) =>
      item?.seller?.user?.name.toLowerCase().includes(value)
    );
    setFilterProposals(filteredData);
  };

  return (
    <section className="invite-freelancers pc-p-3">
      <div className="container-fluid px-5">
        <div className="myjob-table">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <form action="" className="search-form">
                <div className="form-group mb-0">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search Proposals"
                    onChange={handleFilterChange}
                  />
                  <button>
                    <FaSearch />
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="col-lg-3">
              <Link to="#" className="primary-btn black-bg">
                {" "}
                <FaSliders /> Filters{" "}
              </Link>
            </div>
            <div className="col-lg-1">
              <div className="primary-heading color-dark text-right">
                <p className="mb-0">Scope :</p>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="search-form">
                <select className="form-control">
                  <option value="Best Match">Best Match</option>
                </select>
              </div>
            </div> */}
          </div>
        </div>
        {filterProposals.length < 1 && (
          <h3 className="color-secondary text-center mt-5">No Data Found</h3>
        )}
        {filterProposals.map((e) => (
          <div className="invite-box" key={e.id}>
            <div className="row">
              <div className="col-lg-2">
                <div className="invite-box-img">
                  <figure>
                    <img src={e?.attachments || User} alt="profile" />
                  </figure>
                </div>
              </div>
              <div className="col-lg-10">
                <div className="invite-box-content">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="invite-box-content-head">
                        <div className="primary-heading color-dark">
                          <h4>{e?.seller?.user?.name}</h4>
                          {/* <span className="tag">Profession</span>
                          <span className="country">Country</span> */}
                          <ul>
                            <li>${e?.bid}</li>
                            <li>{e?.duration}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <ul className="d-flex justify-content-end">
                        <li className="mr-0">
                          <Link
                            to={CLIENT.viewProposal(e?.id)}
                            className="primary-btn primary-bg mr-3"
                          >
                            View Proposal
                          </Link>
                        </li>
                        {e?.job_post_freelancer == null && 
                        <li>
                          <Link
                            to={CLIENT.clientFreelancer(e?.seller?.user?.id)}
                            state={{ jobId: id }}
                            className="primary-btn secondary-bg"
                            >
                            Hire
                          </Link>
                        </li>
                          }
                      </ul>
                    </div>
                    <div className="col-12">
                      <div className="primary-heading color-dark">
                        <p style={{ textAlign: "justify" }}>{e.cover_letter}</p>
                        <div className="tags">
                          <ul className="tags">
                            {e?.seller?.skills?.map((e, i) => (
                              <li className={"text-capitalize"} key={i}>
                                {e?.name}
                              </li>
                            ))}
                            <li>Data Visualization</li>
                            <li>Business Presentation</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
